import { ruleRunner } from 'validations/ruleRunner';
import { required, minimun, maximum, ruleIf, ruleIfEquals } from 'validations/rules';

const Validations = [
  ruleRunner('recurring_value', 'preço recorrente', required, minimun('1,00')),
  ruleRunner('recurring_frequency', 'frequência', required, minimun(1), maximum(99)),
  ruleRunner('overdue_limit', 'limite de atraso', required, minimun('1'), maximum(99)),
  ruleRunner(
    'limit_charges',
    'limite de cobranças',
    ruleIfEquals('undetermined_charges', false, required),
    ruleIfEquals('undetermined_charges', false, minimun(2)),
    ruleIfEquals('undetermined_charges', false, maximum(99))
  ),
  ruleRunner('membership_price', 'preço da adesão', ruleIf('membership_fee', required), ruleIf('membership_fee', minimun('1,00'))),
  ruleRunner('trial_days', 'dias de trial', ruleIf('trial', required), ruleIf('trial', minimun(1))),
];

export default Validations;
